import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'staff' })
export class StaffPipe implements PipeTransform {

    constructor (){

    }

    transform(staffId: number, ...args: any[]) {
        console.log(">>StaffPipe", staffId, args);
        //return this.documentService.getDownloadLink(documentId);
        let ret = "" + staffId;

        if(args.length > 0){
            if(args[0] == 'firstname-lastname')
                ret = "Ashim Pokharel";
            else if(args[0] == 'lastname-firstname')
                ret = "Pokharel Ashim";
            else if(args[0] == 'userid')
                ret = "APOKHARE";
        }

        if(args.length > 1){
            if(args[1] == "link"){
                ret = `<a href="#">${ret}</a>`;
            }
        }

        return ret;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/staff.pipe.ts